import { render } from "./MarketingModal.vue?vue&type=template&id=75add912"
import script from "./MarketingModal.vue?vue&type=script&lang=js"
export * from "./MarketingModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__